import { render, staticRenderFns } from "./VeteranIcon.vue?vue&type=template&id=2cae007e&scoped=true"
import script from "./VeteranIcon.vue?vue&type=script&lang=js"
export * from "./VeteranIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cae007e",
  null
  
)

export default component.exports